import "./T3SlipSetupStyle.css";

import {
  BackdropCircularProgress,
  DeleteConfirmationDialog,
  EnhancedDropDownRHFWithLabel,
  EnhancedSnackbar,
  IEnhancedDropDownItem,
  ITest,
  LabelPosition,
  StandardPanel,
  TwoColumnLayout,
} from "@websential/cosmic";
import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import {
  FilingDataSetupFieldsPanel,
  T3SlipDataPanel,
  VendorAddressSetupFieldsPanel,
  VendorInfoSetupFieldsPanel,
} from "./Panels";
import { FormProvider, useForm } from "react-hook-form";
import {
  GET_QUERY_KEY,
  INITIAL_SNACKBAR_DATA,
  QUERY_OPTIONS,
  T3_BENEFICIARY_RESOURCE_LITERAL,
  T3_SETUP_SCREEN_SLUG,
  VENDOR_RESOURCE_LITERAL,
} from "../../../common/constants";
import { IResponse, IServerError } from "../../../models/common";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";

import { Avatar } from "primereact/avatar";
import Card from "@mui/material/Card";
import { ClientService } from "../../../services";
import { Divider } from "primereact/divider";
import { Dropdown } from "primereact/dropdown";
import { EnhancedDialog } from "@websential/cosmic";
import FileSaver from "file-saver";
import { FilteredSelectedOtherInfoT3 } from "./Panels/OtherInformationSetupFieldsPanel";
import { IAppState } from "../../../store/reducers";
import { ICountryReferenceModel } from "../../../models/country/ICountryReferenceModel";
import { IDropDownListResponse } from "../../../models/common/IDropDownListResponse";
import { IT3SlipRequestPayload } from "../../../models/t3Slip/IT3SlipRequestPayload";
import { InputText } from "primereact/inputtext";
import { InvoiceDialogPanel } from "../../../components/T4Slip/T4SlipList/InvoiceDialogPanel";
import NativeSelect from "@mui/material/NativeSelect";
import { PrintingService } from "../../../services/PrintingService";
import { ReportsService } from "../../../services/ReportsService";
import { T3SlipService } from "../../../services/T3SlipService";
import { T3SlipSetupToolbar } from "./T3SlipSetupToolbar";
import { T3SlipSetupValidationSchema } from "./validator";
import { T4OtherInformationService } from "../../../components/OtherInformation/otherInformations";
import { T4SlipService } from "../../../services/T4SlipService";
import { TaxSlipSettingsService } from "../../../services/TaxSlipSettingsService";
import { format } from "date-fns";
import { instanceOfIT3SlipResponce } from "../../../common/instance-method";
import { setSelectedActivityLogActions } from "../../../store/actions/activityLogActions";
import { setSelectedINVOICE } from "../../../store/actions";
import { setSelectedStickyNavBar } from "../../../store/actions/stickyNavBarActions";
import { yupResolver } from "@hookform/resolvers/yup";

// import { Card } from "primereact/card";

























export let selectedT3SlipType: any = 400;
export interface IT3SlipSetup extends ITest { }

const SINGLE_RECORD_DATA_QUERY_KEY = "t3-slips-single-data-record";
const SINGLE_Employee_DATA_QUERY_KEY = "employee-data";
const T3_RECIPIENT_DDL_DATA_QUERY_KEY = "t3-recipient-ddl-data-record";


// const useGetT3BeneficiaryDDLItems = (clientId: string, dataRole: string, taxYear: number, type: number) =>
//   useQuery({
//     queryKey: [T3_RECIPIENT_DDL_DATA_QUERY_KEY, clientId, dataRole, taxYear, type],
//     queryFn: (data) => {
//       return T3SlipService.getT3RecipientDDLByRecipientType(
//         clientId,
//         T3_BENEFICIARY_RESOURCE_LITERAL,
//         taxYear,
//         type
//       );
//     },
//     refetchOnWindowFocus: false,
//   });
const useGetEmployeeDDLItems = (clientId: string, dataRole: string, taxYear: number) =>
  useQuery({
    queryKey: [T3_RECIPIENT_DDL_DATA_QUERY_KEY, clientId, dataRole, taxYear],
    queryFn: (data) => {
      return T4SlipService.getEmployeeDDL(clientId, dataRole, taxYear);
    },
    refetchOnWindowFocus: false,
  });
const useGetData = (
  id: string | undefined,
  clientId: string,
  taxYear: number
) => useQuery({
  queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, id],
  queryFn: () => { return T3SlipService.getT3SlipById(id, clientId, taxYear) },
  refetchOnWindowFocus: false
});

// const useGetForeingCurrencyDDL = () =>
//   useQuery({
//     queryKey: [""],
//     queryFn: (data) => {
//       return T3SlipService.getForeingCurrencyDDL();
//     },
//     refetchOnWindowFocus: false
//   });

const useGetResourceInformationById = (
  resourceId: string,
  clientId: string,
  roleName: string
) => useQuery({
  queryKey: [SINGLE_Employee_DATA_QUERY_KEY, resourceId, clientId, roleName],
  queryFn: () => { return T3SlipService.getResourceInformationById(resourceId, clientId, roleName) },
  refetchOnWindowFocus: false
});

const parseJSONLikeString = (str: string) => {
  // Use regular expressions to add double quotes around keys and string values
  const modifiedString = str.replace(/(\w+):/g, '"$1":').replace(/'/g, '"');

  // Convert the modified JSON string to an object using JSON.parse()
  return JSON.parse(modifiedString);
};
// const useGetGlobalVariables = (taxYear: number) =>
//   useQuery({
//     queryKey: [GET_QUERY_KEY.GET_GLOBAL_VARIABLES_BY_YEAR, taxYear],
//     queryFn: (data) => {
//       return TaxSlipSettingsService.getGlobalVariables(taxYear);
//     },
//     refetchOnWindowFocus: false
//   });

// const useGetSlipIds = (
//   tag: string,
//   clientId: string,
//   taxYear: number
// ) =>
//   useQuery({
//     queryKey: ["get-slip-ids", tag, clientId, taxYear],
//     queryFn: (data) => {
//       return T4SlipService.getSlipIds(tag, clientId, taxYear);
//     },
//     refetchOnWindowFocus: false
//   });

// const useGetCompanyData = (id: string | undefined) =>
//   useQuery({
//     queryKey: ["client-get-by-id", id],
//     queryFn: (data) => {
//       return ClientService.getById(id);
//     },
//     refetchOnWindowFocus: false
//   });

export const T3SlipSetup: FC<IT3SlipSetup> = ({ testId }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const clientId = useSelector((state: IAppState) => state.client.id);
  const [snackbarData, setSnackbarData] = useState<any>(INITIAL_SNACKBAR_DATA);
  const taxYear = useSelector((state: IAppState) => state.taxYear.year);
  const [selectedResource, setSelectedResource] = useState("create-new");
  const [selectedResourceSlip, setSelectedResourceSlip] =
    useState("create-new");
  const [invoicePaymentFor, setInvoicePaymentFor] = useState(10)
  const dashboardApiData = useSelector((state: IAppState) => state.dashboardApisData);
  const [onResourceSelectionAPIsCalls, setOnResourceSelectionAPIsCalls] =
    useState(false);

  const [selectedResourceSlipList, setSelectedResourceSlipList] = useState<
    IDropDownListResponse[]
  >([{ label: "Create New", value: "create-new" }]);
  const [openInvoiceDialog, setInvoiceDialogOpen] = useState(false);
  const [invoiceData, setInvoiceData] = useState<any>([]);
  const [isLoadingDataa, setIsLoadingData] = useState(false);

  const [selectedResourceList, setSelectedResourceList] = useState<
    IDropDownListResponse[]
  >([{ label: "Create New", value: "create-new" }]);

  const [isLoadingAdjustedData, setIsLoadingAdjustedData] = useState(false);
  const [editedResourceId, setEditedResourceId] = useState("");
  // for delete row
  const [openDialog, setDialogOpen] = useState(false);
  const [apiAction, setApiAction] = useState("");
  const [singleDelete, setSingleDelete] = useState<boolean>(false);
  const [t3SlipId, setT3SlipId] = useState<any>("");
  const clientName = useSelector((state: IAppState) => state.client.clientName);
  const isLoadingActivityLogData = useSelector(
    (state: IAppState) => state.isLoadAxiosCall.isLoading
  );

  const [resourceListWithoutCreateNew, setResourceListWithoutCreateNew] =
    useState<any>(undefined);
  const [secondRecipientDDL, setSecondRecipientDDL] = useState<any>(undefined);
  const [selectedCard, setSelectedCard] = useState<any>(null);
  const [itemSearch, setItemSearch] = useState("");
  const [sidePanelsVisibility, setSidePanelsVisibility] = useState(true);
  const [
    selectedSecondRecipientResourceActualIdValue,
    setSelectedSecondRecipientResourceActualIdValue,
  ] = useState<any>(undefined);
  const [recipientTypeValue, setRecipientTypeValue] = useState<any>(undefined);

  const [selectedOtherInformation, setSelectedOtherInformation] =
    useState(false);
  const [oiInEdit, setOiInEdit] = useState(false);

  const [T3OtherInformationList, setT3OtherInformationList] =
    useState<any>(undefined);
  useEffect(() => {
    //Load OtherInformationList
    setIsLoadingAdjustedData(true);
    setTimeout(() => {
      setIsLoadingAdjustedData(false);
    }, 2000);
    const fetchData = async () => {
      try {
        const response: any = await T4OtherInformationService.getT3OI();
        setT3OtherInformationList(response);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  //one state which store both new cretaed and edited slip data
  const [T3SlipRecord, setT3SlipRecord] = useState<any>(undefined);
  // when  I setValue of otherinformation inside async calls method then facing issue while click on add more so we have to use state method to show otherinformation 
  const [slipOtherInformation, setSlipOtherInformation] =
    useState<any>([]);

  // const queryClient = useQueryClient();


  const [CountryResponse] = useState<ICountryReferenceModel>({
    id: 1,
    name: "Canada",
    shortCode: "CAN",
  });

  // for edit
  const queryClient = useQueryClient();
  const { id } = useParams();

  let notStartedSlipId = "";
  let completedSlipId = "";
  if (id !== undefined && onResourceSelectionAPIsCalls === false) {
    if (id?.length > 24) {
      notStartedSlipId = id;
    }
    if (id?.length === 24) {
      completedSlipId = id;
    }
  }

  const DEFAULT_VALUES = {
    clientId: clientId,
    taxYear: taxYear,
  };

  // Function to sort the data array by the label field
  // sort side cards items 
  const sortData = (data: IDropDownListResponse[]): IDropDownListResponse[] => {
    return data.sort((a, b) => a.label.localeCompare(b.label));
  };

  const { isPending: isSubmitting, mutate: submitFlexFields } = useMutation({
    mutationFn: T3SlipService.create,

    onSuccess: (
      res: IT3SlipRequestPayload | IServerError | IResponse | any
    ) => {
      if (res.data && instanceOfIT3SlipResponce(res.data)) {
        queryClient.invalidateQueries({ queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, res.data.id] });
        formMethods.setValue("id", res.data.id);
        setSnackbarData({
          open: true,
          message: "Data has been submitted successfully!",
          severity: "success",
        });
        // refectchT3SlipIds()
        if (res.status === 201 && selectedResourceSlip === "create-new") {
          (async () => {
            try {

              const response: any =
                await T3SlipService.getResourceSlipDropDownList(
                  res.data?.resource?.externalId,
                  clientId,
                  taxYear
                );
              if (response && Array.isArray(response)) {
                let resourceSlipList: IDropDownListResponse[] =
                  response.map((resourceSlip: IDropDownListResponse) => ({
                    label: resourceSlip.label,
                    value: resourceSlip.value,
                  }));

                resourceSlipList.unshift({
                  label: "Create New",
                  value: "create-new",
                });


                setSelectedResourceSlipList(resourceSlipList);
                formMethods.setValue(
                  "selectedSlip",
                  res.data.id
                );
                // createNewActionFromSlipDDL();
                // formMethods.setValue("comparison", [
                //   { amount: 0, code: "", label: "" },
                // ]);
                let path = `/taxslip/t3/setup/${res.data.id}`;
                navigate(path);
              }
            } catch (error) {
              console.error("Error fetching data:", error);
            }
          })();
          setOnResourceSelectionAPIsCalls(true)
          setSelectedResourceSlip(res.data.id)
        }
      } else {
        setSnackbarData({
          open: true,
          // message: "Something went wrong, try again later!",
          message: res.message ? res.message : res.data.message,
          severity: "error",
        });
      }
      //Load T3 Recipient DDL
      // const fetchData = async () => {
      //   const recipientType = formMethods.getValues("recipientType");
      //   try {
      //     const response: any =
      //       await T3SlipService.getT3RecipientDDLByRecipientType(
      //         clientId,
      //         T3_BENEFICIARY_RESOURCE_LITERAL,
      //         taxYear,
      //         res.recipientType ? res.recipientType : recipientType
      //       );


      //     if (response && Array.isArray(response)) {
      //       let resources: IDropDownListResponse[] = response.map(
      //         (resourceItem: IDropDownListResponse) => ({
      //           // id: resourceItem.id,
      //           label: resourceItem.label,
      //           value: resourceItem.value,
      //         })
      //       );

      //       resources.unshift({
      //         label: "Create New",
      //         value: "create-new",
      //       });

      //       setSelectedResourceList(resources);

      //     }
      //     setResourceListWithoutCreateNew(sortData(response));
      //   } catch (error) {
      //     console.error("Error fetching data:", error);
      //   }
      // };

      // fetchData();
      // console.log("res.data.recipientType", res.data.recipientType)
      const recipientType = formMethods.getValues("recipientType");
      // queryClient.invalidateQueries({
      //   queryKey: [T3_RECIPIENT_DDL_DATA_QUERY_KEY, clientId,
      //     T3_BENEFICIARY_RESOURCE_LITERAL,
      //     taxYear,
      //     res.data.recipientType ? res.data.recipientType : recipientType],exact: true,
      // });
      queryClient.invalidateQueries({
        queryKey: [T3_RECIPIENT_DDL_DATA_QUERY_KEY, clientId, T3_BENEFICIARY_RESOURCE_LITERAL, taxYear],
      });
      setSelectedCard(String(res.data.resource.externalId));
      formMethods.setValue(
        "selectedEmployee",
        res.data.resource.externalId
      );
      setSelectedResource(res.data.resource.externalId);
      //load slip Data
      if (res.data && res.data?.resource) {
        setT3SlipRecord(res.data);
        setSelectedResource(res.data?.resource?.externalId);
      }
      selectedT3SlipType = formMethods.getValues("slipType");
      setSelectedOtherInformation(true);
    },
    onError: (err: any) => {
      setSnackbarData({
        open: true,
        message: err.message,
        severity: "error",
      });
    },
  }
  );
  const [isPendingSlipData, setIsPendingSlipData] = useState(false);
  //when cretae-new seleted from slip ddl
  const createNewActionFromSlipDDL = () => {
    setSelectedOtherInformation(false);
    setT3SlipRecord(undefined)
    setSelectedResourceSlip("create-new");
    formMethods.setValue(
      "selectedSlip",
      "create-new"
    );
    formMethods.setValue(
      "actualAmountOfEligibleDivinends",
      "0.00"
    );
    formMethods.setValue(
      "taxableAmountOfEligibleDividends",
      "0.00"
    );
    formMethods.setValue(
      "dividendTaxCreditForEligibleDividends",
      "0.00"
    );
    formMethods.setValue(
      "capitalGains",
      "0.00"
    );
    formMethods.setValue(
      "capitalGainsEligible",
      "0.00"
    );
    formMethods.setValue(
      "actualAmountOtherThanEligible",
      "0.00"
    );
    formMethods.setValue(
      "taxableAmountOtherThanEligible",
      "0.00"
    );
    formMethods.setValue(
      "dividendTaxCreditOtherThanEligible",
      "0.00"
    );
    formMethods.setValue(
      "otherIncome",
      "0.00"
    );
    formMethods.setValue("optionalTextToPrintOnTheSlip", "");
    formMethods.setValue(
      "footNotes",
      ""
    );
    formMethods.setValue("slipStatus", 200);
    formMethods.setValue("comparison", [{ amount: 0, code: "", label: "" }]);
    // setSlipOtherInformation([])
    // formMethods.setValue("comparison", []);
    setSlipOtherInformation([{ amount: 0, code: 'null', label: 'Empty Field' }])
  };

  const resourceDataByIdPass = useCallback(
    (resourceDataById: any) => {
      if (resourceDataById) {
        setIsPendingSlipData(true);
        Object.keys(resourceDataById).forEach((fieldName) => {
          // @ts-ignore
          const fieldValue = resourceDataById[fieldName];

          formMethods.setValue(fieldName, fieldValue);

          if (fieldName === "email") {
            if (fieldValue !== null) {
              formMethods.setValue(fieldName, fieldValue);
            } else {
              // const maskedStatus: any = sessionStorage.getItem("maskEnabled");
              if (dashboardApiData.masked_status) {
                formMethods.setValue(fieldName, "ze*****3@gmail.com");
              } else {
                formMethods.setValue(fieldName, "");
              }
            }
          }
          if (fieldName === "address") {
            Object.keys(fieldValue).forEach((resourceFieldName) => {
              const resourceFieldValue = fieldValue[resourceFieldName];
              // @ts-ignore

              Object.keys(resourceFieldValue).forEach((resourceFieldNameNew) => {
                const resourceFieldValueNew =
                  resourceFieldValue[resourceFieldNameNew];
                // @ts-ignore

                formMethods.setValue(resourceFieldNameNew, resourceFieldValueNew);

                if (resourceFieldNameNew === "country") {
                  formMethods.setValue(
                    resourceFieldNameNew,
                    resourceFieldValueNew.name ?? undefined
                  );
                }
                if (resourceFieldNameNew === "province") {
                  let id = resourceFieldValueNew.id;
                  let name = resourceFieldValueNew.name;
                  let shortCode = resourceFieldValueNew.shortCode;



                  formMethods.setValue(
                    resourceFieldNameNew,
                    `{id:${id}, name: "${name}",shortCode:"${shortCode}"}`
                    // '{id:1, name: "Alberta",shortCode:"AB"}'
                  );
                }
              });
            });
          }
          if (fieldName === "id" && onResourceSelectionAPIsCalls === false) {
            //for auto selected card
            setSelectedCard(String(fieldValue));
            formMethods.setValue(
              "selectedVendor",
              fieldValue
            );
            setSelectedResource(fieldValue);
          }
          if (fieldName === "uniqueIdentifier") {
            const formattedNumber =
              fieldValue !== null
                ? fieldValue.replace(/(\d{3})(\d{3})(\d{3})/, "$1-$2-$3")
                : undefined;
            formMethods.setValue("uniqueIdentifier", formattedNumber);
          }

          if (fieldName === "firstName") {
            formMethods.setValue(
              "firstName",
              fieldValue !== null ? fieldValue : undefined
            );
          }
          // }
          if (fieldName === "metaFields") {
            fieldValue.forEach((obj: any) => {
              formMethods.setValue(obj.name, obj.value);
              if (obj.name === 'initial') {
                formMethods.setValue('initials', obj.value)
              }
              if (obj.name === "recipientType") {
                formMethods.setValue(obj.name, parseInt(obj.value));
              }

            });
          }
        });
        createNewActionFromSlipDDL();
        setIsPendingSlipData(false);
      }
    },
    [onResourceSelectionAPIsCalls]
  );

  // slipDataById in function
  const slipDataByIdPass = useCallback(
    (slipDataById: any, onResourceSelectionAPIsCalls: boolean) => {
      setIsPendingSlipData(true);
      // console.log('slipDataById', slipDataById)
      if (slipDataById) {
        Object.keys(slipDataById).forEach(
          (fieldName) => {

            // @ts-ignore
            const fieldValue =
              slipDataById[fieldName];

            // @ts-ignore

            if (
              typeof fieldValue !== "object"
            ) {
              // @ts-ignore
              formMethods.setValue(
                fieldName,
                fieldValue ?? undefined
              );
            } else if (
              fieldValue !== null ||
              undefined
            ) {

              Object.keys(fieldValue).forEach(
                (objFieldName: any) => {

                  // @ts-ignore
                  const objFieldValue =
                    fieldValue[objFieldName];


                  if (
                    typeof objFieldValue !==
                    "object"
                  ) {
                    // @ts-ignore
                    formMethods.setValue(
                      objFieldName,
                      objFieldValue
                    );
                  }
                  if (
                    fieldName === "resource"
                  ) {
                    if (
                      objFieldName ===
                      "externalId"
                    ) {

                      //for auto selected card
                      setSelectedCard(
                        String(
                          objFieldValue
                        )
                      );
                      formMethods.setValue(
                        "selectedVendor",
                        objFieldValue
                      );
                      if (!onResourceSelectionAPIsCalls) {
                        (async () => {
                          try {
                            const response: any =
                              await T3SlipService.getResourceSlipDropDownList(
                                objFieldValue,
                                clientId,
                                taxYear
                              );

                            // formMethods.setValue("selectedSlip", response[0].value);

                            if (
                              response &&
                              Array.isArray(
                                response
                              )
                            ) {
                              let resourceSlipList: IDropDownListResponse[] =
                                response.map(
                                  (
                                    resourceSlip: IDropDownListResponse
                                  ) => ({
                                    label:
                                      resourceSlip.label,
                                    value:
                                      resourceSlip.value,
                                  })
                                );

                              resourceSlipList.unshift(
                                {
                                  label:
                                    "Create New",
                                  value:
                                    "create-new",
                                }
                              );



                              setSelectedResourceSlipList(
                                resourceSlipList
                              );
                              //for Cards scenario
                              if (
                                resourceSlipList &&
                                resourceSlipList.length >
                                1
                              ) {
                                setSelectedResourceSlip(
                                  String(id)
                                );
                              } else {
                                setSelectedResourceSlip(
                                  "create-new"
                                );
                              }
                            }
                          } catch (error) {
                            console.error(
                              "Error fetching data:",
                              error
                            );
                          }
                        })();
                        setSelectedResource(
                          objFieldValue
                        );
                      }
                    }
                    setEditedResourceId(
                      fieldValue.externalId
                    );
                    if (
                      objFieldName === "email"
                    ) {
                      if (
                        objFieldValue !== null
                      ) {
                        formMethods.setValue(
                          objFieldName,
                          objFieldValue
                        );
                      } else {
                        // const maskedStatus: any =
                        //   sessionStorage.getItem(
                        //     "maskEnabled"
                        //   );

                        if (
                          dashboardApiData.masked_status
                        ) {
                          formMethods.setValue(
                            objFieldName,
                            "ze*****3@gmail.com"
                          );
                        } else {
                          formMethods.setValue(
                            objFieldName,
                            ""
                          );
                        }
                      }
                    }
                  }
                  if (
                    objFieldName === "province"
                  ) {
                    let id = objFieldValue.id;
                    let name =
                      objFieldValue.name;
                    let shortCode =
                      objFieldValue.shortCode;


                    formMethods.setValue(
                      objFieldName,
                      // '{id:9, name: "Ontario",shortCode:"ON"}'
                      `{id:${id}, name: "${name}",shortCode:"${shortCode}"}`
                    );
                  }
                  if (
                    objFieldName === "country"
                  ) {
                    formMethods.setValue(
                      objFieldName,
                      objFieldValue.name ??
                      undefined
                    );
                  }
                  if (
                    objFieldName ===
                    "uniqueIdentifier"
                  ) {
                    const formattedNumber =
                      objFieldValue !== null
                        ? objFieldValue.replace(
                          /(\d{3})(\d{3})(\d{3})/,
                          "$1-$2-$3"
                        )
                        : undefined;
                    formMethods.setValue(
                      "uniqueIdentifier",
                      formattedNumber
                    );
                  }

                }
              );
            }
            //set slip type according to edited row data for submit button action
            if (fieldName === "slipType") {
              selectedT3SlipType = fieldValue;
              setIsLoadingAdjustedData(true);
              setTimeout(() => {
                setIsLoadingAdjustedData(false);
              }, 1000);
            }
            if (
              fieldName === "otherInformation"
            ) {
              // setSlipOtherInformation(fieldValue)
              setSlipOtherInformation([])
              if (fieldValue && fieldValue !== null && fieldValue.length !== 0) {
                setOiInEdit(true);
                formMethods.setValue("comparison", fieldValue);
              } else {
                setOiInEdit(true);
                formMethods.setValue("comparison", [
                  { amount: 0, code: "", label: "" },
                ]);
              }
            }
            if (fieldName === "id") {
              formMethods.setValue(
                "selectedSlip",
                fieldValue
              );
              let path = `/taxslip/t3/setup/${fieldValue}`;
              navigate(path);
            }
            if (fieldName === "slipData") {
              Object.keys(fieldValue).forEach(
                (slipDataFieldName: any) => {
                  const slipDataFieldValue =
                    fieldValue[
                    slipDataFieldName
                    ];

                  formMethods.setValue(
                    slipDataFieldName,
                    slipDataFieldValue &&
                      slipDataFieldValue !==
                      null
                      ? parseFloat(
                        slipDataFieldValue
                      ).toFixed(2)
                      : "0.00"
                  );
                  if (slipDataFieldName === 'optionalTextToPrintOnTheSlip') {
                    formMethods.setValue(
                      slipDataFieldName,
                      slipDataFieldValue &&
                        slipDataFieldValue !==
                        null
                        ? slipDataFieldValue : ""
                    );
                  }
                  if (slipDataFieldName === 'footNotes') {
                    formMethods.setValue(
                      slipDataFieldName,
                      slipDataFieldValue &&
                        slipDataFieldValue !==
                        null
                        ? slipDataFieldValue : ""
                    );
                  }
                }
              );
            }
            if (
              fieldName === "secondExternalId"
            ) {
              if (fieldValue !== null) {
                // (async () => {
                //   try {
                //     const responseAssociationId =
                //       await T4SlipService.getRoleAssociationId(
                //         fieldValue
                //       );
                formMethods.setValue(
                  "secondRecipientName",
                  fieldValue
                );
                //   } catch {}
                // })();
              }
            }
            if (
              fieldName ===
              "recipientType"
            ) {
              formMethods.setValue(
                "recipientType",
                fieldValue
              );
              // console.log("fieldValue11", fieldValue)
              if (fieldValue === 20) {
                const individual = formMethods.getValues("individual");
                if (individual === false) {
                  (async () => {
                    try {
                      setIsLoadingAdjustedData(true);
                      const response: any =
                        await T3SlipService.getT3RecipientDDLByRecipientType(
                          clientId,
                          T3_BENEFICIARY_RESOURCE_LITERAL,
                          taxYear,
                          30
                        );

                      setSecondRecipientDDL(response);
                    } catch (error) {
                      console.error("Error fetching data:", error);
                    } finally {
                      setIsLoadingAdjustedData(false);
                    }
                  })();
                } else if (individual === true) {
                  (async () => {
                    try {
                      setIsLoadingAdjustedData(true);
                      const response: any =
                        await T3SlipService.getT3RecipientDDLByRecipientType(
                          clientId,
                          T3_BENEFICIARY_RESOURCE_LITERAL,
                          taxYear,
                          10
                        );

                      setSecondRecipientDDL(response);
                    } catch (error) {
                      console.error("Error fetching data:", error);
                    } finally {
                      setIsLoadingAdjustedData(false);
                    }
                  })();
                }
              }
            }

          }
        );
        setIsPendingSlipData(false);
      }
    },
    []
  );

  // const {
  //   isLoading: isLoadingForeignCurrencyDDL,
  //   data: foreignCurrencyDDList,
  // } = useGetForeingCurrencyDDL();

  // const foreignCurrencyDDListItems = useMemo(() => {
  //   if (foreignCurrencyDDList && Array.isArray(foreignCurrencyDDList)) {
  //    
  //     let foreignCurrency: any[] = foreignCurrencyDDList.map(
  //       (resourceItem: any) => ({
  //         label: resourceItem.label,
  //         value: resourceItem.value,
  //         name: resourceItem.name,
  //       })
  //     );
  //     foreignCurrency.unshift({
  //       label: "--",
  //       value: null,
  //     });
  //    
  //     return foreignCurrency;
  //   }
  // }, [foreignCurrencyDDList]);

  // for edit

  //for that slips which are completed
  const { isPending: isLoadingData, data: selectedT3SlipsData } = useGetData(
    completedSlipId,
    clientId,
    taxYear
  );

  // const { isPending: isPendingEmployeeDDLItems, data: employeeDDLItems } =
  //   useGetT3BeneficiaryDDLItems(clientId, T3_BENEFICIARY_RESOURCE_LITERAL, taxYear, 20);
  const { isPending: isPendingEmployeeDDLItems, data: employeeDDLItems } =
    useGetEmployeeDDLItems(clientId, T3_BENEFICIARY_RESOURCE_LITERAL, taxYear);

  useEffect(() => {
    if (employeeDDLItems) {
      if (employeeDDLItems && Array.isArray(employeeDDLItems)) {
        let resources: IDropDownListResponse[] = employeeDDLItems.map(
          (resourceItem: IDropDownListResponse) => ({
            // id: resourceItem.id,
            label: resourceItem.label,
            value: resourceItem.value,
          })
        );

        resources.unshift({
          label: "Create New",
          value: "create-new",
        });

        setSelectedResourceList(resources);
      }
      setResourceListWithoutCreateNew(sortData(employeeDDLItems));
    }
  }, [employeeDDLItems])

  useEffect(() => {
    if (selectedT3SlipsData) {
      setT3SlipRecord(selectedT3SlipsData);
    }
  }, [selectedT3SlipsData]);


  //for that slips which are not started yet
  const {
    isLoading: isLoadingNotStartedSlipId,
    data: selectedNotStartedResourceData,
    // refetch: refetchResourceSlips,
  } = useGetResourceInformationById(
    notStartedSlipId,
    clientId,
    T3_BENEFICIARY_RESOURCE_LITERAL
  );


  const formMethods = useForm<any>({
    resolver: yupResolver(T3SlipSetupValidationSchema),
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: DEFAULT_VALUES,
  });
  /**
   * Handle when the form is submitted.
   *
   * @param {IT3SlipRequestPayload} formData
   */
  const onSubmit = (formData: any) => {
    //province is in string format and by using this we convert that in object
    const jsonString = formData.province as string;
    // Custom parsing function to convert the JSON-like string to an object
    const parseJSONLikeString = (str: string) => {
      // Use regular expressions to add double quotes around keys and string values
      const modifiedString = str.replace(/(\w+):/g, '"$1":').replace(/'/g, '"');
      // Convert the modified JSON string to an object using JSON.parse()
      return JSON.parse(modifiedString);
    };
    // Convert the JSON-like string to an object
    const provinceObject = parseJSONLikeString(jsonString);


    //province is in string format and by using this we convert that in object
    // const jsonStringPoe = formData.provinceOfEmployment as string;
    // Custom parsing function to convert the JSON-like string to an object
    // const parseJSONLikeStringPeo = (str: string) => {
    //   // Use regular expressions to add double quotes around keys and string values
    //   const modifiedString = str.replace(/(\w+):/g, '"$1":').replace(/'/g, '"');
    //   // Convert the modified JSON string to an object using JSON.parse()
    //   return JSON.parse(modifiedString);
    // };
    // Convert the JSON-like string to an object
    // const poeObject = parseJSONLikeStringPeo(jsonStringPoe);


    //other Information
    const getValue = formMethods.getValues("comparison");

    const finalOtherInformatioItems = FilteredSelectedOtherInfoT3.map(
      (item: any) => {
        const valueItem = getValue.find(
          (value: any) => value.code === item.code
        );
        const getLabelIfMissingInItem =
          T3OtherInformationList &&
          T3OtherInformationList.find(
            (value: any) => value.value === item.code
          );

        return {
          ...item,
          amount: valueItem.amount,
          label: getLabelIfMissingInItem.label,
        };
      }
    );

    if (formData.recipientType === 20) {
      // (async () => {
      //   try {
      //       const selectedSecondRecipientResourceActualId =
      //         await T4SlipService.getResourceActualId(formData.secondRecipientName && formData.secondRecipientName);
      //       setSelectedSecondRecipientResourceActualIdValue(
      //         selectedSecondRecipientResourceActualId
      //       );
      const selectedSecondRacipientObject =
        secondRecipientDDL &&
        secondRecipientDDL.find(
          (item: any) => item.value === formData.secondRecipientName
        );

      const requestPayload: any = {
        clientId: clientId,
        taxYear: taxYear,
        id:
          selectedT3SlipsData && selectedT3SlipsData.resource
            ? selectedT3SlipsData.id
            : undefined,
        recipientType: formData.recipientType,
        reflectMasterData: formData.reflectMasterData,
        // isRl3Create: formData.isRl3Create,
        slipType: formData.slipType,
        secondRecipientName:
          formData.recipientType === 20
            ? selectedSecondRacipientObject && selectedSecondRacipientObject.label
            : undefined,
        slipStatus: formData.slipStatus,
        otherInformation: formData.comparison[0].code !== "" ? finalOtherInformatioItems : [],
        resource: {
          externalId:
            selectedResource !== "create-new"
              ? selectedResource
              : selectedT3SlipsData && selectedT3SlipsData.resource
                ? selectedT3SlipsData.resource.externalId
                : selectedNotStartedResourceData &&
                  selectedNotStartedResourceData.id
                  ? selectedNotStartedResourceData.id
                  : undefined,
          firstName:
            formData.recipientType === 10 && formData.name1 && formData.name1.length > 0 ?
              formData.name1 :
              formData.recipientType === 20 && formData.name1 && formData.name1.length > 0 ?
                formData.name1 :
                undefined,
          initials: formData.recipientType === 10 ? formData.initials : formData.recipientType === 20 ? formData.initials : '',
          lastName:
            formData.recipientType === 10 && formData.name2 && formData.name2.length > 0 ?
              formData.name2 :
              formData.recipientType === 20 && formData.name2 && formData.name2.length > 0 ?
                formData.name2 :
                undefined,
          // dateOfBirth:formData.dateOfBirth,
          socialInsuranceNumber:
            formData.recipientType === 10 && formData.uniqueIdentifier && formData.uniqueIdentifier !== "" ?
              formData.uniqueIdentifier.replace(/-/g, "") :
              formData.recipientType === 20 && formData.uniqueIdentifier && formData.uniqueIdentifier !== "" ?
                formData.uniqueIdentifier.replace(/-/g, "") :
                undefined,
          address: formData.addressLine1,
          city: formData.city,
          country: CountryResponse,
          postCode:
            formData.postalCode &&
            formData.postalCode.replace(/[a-z]/g, (match: string) =>
              match.toUpperCase()
            ),
          province: provinceObject, //when edit then it show n select so this technique is use bcz we cant assign fieldvalue according to field name by using direct object so first we change that oobject to string then we chnage that string to obj and send to payload
          email: formData.email !== "" && formData.email !== "ze*****3@gmail.com"
            ? formData.email
            : undefined,
        },
        individual: formData.recipientType === 20 && formData.individual,
        slipData: {
          actualAmountOfEligibleDivinends: formData.actualAmountOfEligibleDivinends && formData.actualAmountOfEligibleDivinends !== null ?
            parseFloat(
              formData.actualAmountOfEligibleDivinends.replace(/[$,]/g, '')
            ) : 0,
          capitalGains: formData.capitalGains && formData.capitalGains !== null ?
            parseFloat(
              formData.capitalGains.replace(/[$,]/g, '')
            ) : 0,
          capitalGainsEligible: formData.capitalGainsEligible && formData.capitalGainsEligible !== null ?
            parseFloat(formData.capitalGainsEligible.replace(/[$,]/g, '')) : 0,
          actualAmountOtherThanEligible: formData.actualAmountOtherThanEligible && formData.actualAmountOtherThanEligible !== null ?
            parseFloat(
              formData.actualAmountOtherThanEligible.replace(/[$,]/g, '')
            ) : 0,
          otherIncome: formData.otherIncome && formData.otherIncome !== null ?
            parseFloat(
              formData.otherIncome.replace(/[$,]/g, '')
            ) : 0,
          optionalTextToPrintOnTheSlip: formData.optionalTextToPrintOnTheSlip !== '' ? formData.optionalTextToPrintOnTheSlip : undefined,
          footNotes: formData.footNotes !== '' ? formData.footNotes : undefined,
        },
        secondExternalId: formData.secondRecipientName && formData.secondRecipientName,
      };


      // submitFlexFields(formData);
      submitFlexFields(requestPayload);
      //   } catch (error: any) {
      //     alert(error)
      //   }
      // })();
    } else {
      //   (async () => {
      //   try {

      //     let secondRecipient =
      //       formData.secondRecipientName && formData.secondRecipientName;
      //     if (secondRecipient) {
      //       const selectedSecondRecipientResourceActualId =
      //         await T4SlipService.getResourceActualId(secondRecipient);
      //       setSelectedSecondRecipientResourceActualIdValue(
      //         selectedSecondRecipientResourceActualId
      //       );
      //     }
      //   } catch (error: any) {}
      // })();
      const selectedSecondRacipientObject =
        secondRecipientDDL &&
        secondRecipientDDL.find(
          (item: any) => item.value === formData.secondRecipientName
        );


      const requestPayload: any = {
        clientId: clientId,
        taxYear: taxYear,
        id:
          selectedT3SlipsData && selectedT3SlipsData.resource
            ? selectedT3SlipsData.id
            : T3SlipRecord && T3SlipRecord.id ? T3SlipRecord.id
              : undefined,
        recipientType: formData.recipientType,
        reflectMasterData: formData.reflectMasterData,
        // isRl3Create: formData.isRl3Create,
        slipType: formData.slipType,
        // secondRecipientName:
        //   formData.recipientType === 20
        //     ? selectedSecondRacipientObject && selectedSecondRacipientObject.label
        //     : undefined,
        slipStatus: formData.slipStatus,
        otherInformation: formData.comparison[0].code !== "" ? finalOtherInformatioItems : [],
        resource: {
          externalId:
            selectedResource !== "create-new"
              ? selectedResource
              : selectedT3SlipsData && selectedT3SlipsData.resource
                ? selectedT3SlipsData.resource.externalId
                : selectedNotStartedResourceData &&
                  selectedNotStartedResourceData.id
                  ? selectedNotStartedResourceData.id
                  : undefined,
          firstName:
            formData.recipientType === 10 && formData.name1 && formData.name1.length > 0 ?
              formData.name1 :
              formData.recipientType === 20 && formData.name1 && formData.name1.length > 0 ?
                formData.name1 :
                undefined,
          initials: formData.recipientType === 10 ? formData.initials : formData.recipientType === 20 ? formData.initials : '',
          lastName:
            formData.recipientType === 10 && formData.name2 && formData.name2.length > 0 ?
              formData.name2 :
              formData.recipientType === 20 && formData.name2 && formData.name2.length > 0 ?
                formData.name2 :
                undefined,
          // dateOfBirth:formData.dateOfBirth,
          socialInsuranceNumber:
            formData.recipientType === 10 && formData.uniqueIdentifier && formData.uniqueIdentifier !== "" ?
              formData.uniqueIdentifier.replace(/-/g, "") :
              formData.recipientType === 20 && formData.uniqueIdentifier && formData.uniqueIdentifier !== "" ?
                formData.uniqueIdentifier.replace(/-/g, "") :
                undefined,
          address: formData.addressLine1,
          city: formData.city,
          country: CountryResponse,
          postCode:
            formData.postalCode &&
            formData.postalCode.replace(/[a-z]/g, (match: string) =>
              match.toUpperCase()
            ),
          province: provinceObject, //when edit then it show n select so this technique is use bcz we cant assign fieldvalue according to field name by using direct object so first we change that oobject to string then we chnage that string to obj and send to payload
          // provinceOfEmployment: poeObject,
          email: formData.email !== "" && formData.email !== "ze*****3@gmail.com"
            ? formData.email
            : undefined,
          businessName:
            formData.firstLineOfRecipientName +
            formData.secondLineOfRecipientName, //First line of recipient name * Second line of recipient name *
          businessNumber:
            formData.recipientType === 30 && formData.businessNumber !== '' ?
              formData.businessNumber :
              formData.recipientType === 50 && formData.businessNumber !== '' ?
                formData.businessNumber :
                undefined,
        },
        individual: formData.recipientType === 20 && formData.individual,
        trustAccountNumber: formData.recipientType === 40 ?
          formData.trustAccountNumber && formData.trustAccountNumber.charAt(0) === 'T' ? formData.trustAccountNumber : `T${formData.trustAccountNumber}` : undefined,
        firstLineOfRecipientName:
          formData.recipientType === 30 && formData.firstLineOfRecipientName !== "" ?
            formData.firstLineOfRecipientName :
            formData.recipientType === 40 && formData.firstLineOfRecipientName !== "" ?
              formData.firstLineOfRecipientName :
              formData.recipientType === 50 && formData.firstLineOfRecipientName !== "" ?
                formData.firstLineOfRecipientName :
                undefined,
        secondLineOfRecipientName:
          formData.recipientType === 30 && formData.secondLineOfRecipientName !== "" ?
            formData.secondLineOfRecipientName :
            formData.recipientType === 40 && formData.secondLineOfRecipientName !== "" ?
              formData.secondLineOfRecipientName :
              formData.recipientType === 50 && formData.secondLineOfRecipientName !== "" ?
                formData.secondLineOfRecipientName :
                undefined,
        // name3: (formData.recipientType === 20 && formData.individual === false) ? selectedSecondRacipientObject && selectedSecondRacipientObject.label.substring(0, selectedSecondRacipientObject.label.indexOf(' ')) : formData.name3 !== "" ? formData.name3 : undefined,
        // name4: (formData.recipientType === 20 && formData.individual === false) ? selectedSecondRacipientObject && selectedSecondRacipientObject.label.substring(selectedSecondRacipientObject.label.indexOf(' ') + 1) : formData.name4 !== "" ?formData.name4 : undefined,
        // initials1: formData.initials1,
        slipData: {
          actualAmountOfEligibleDivinends: formData.actualAmountOfEligibleDivinends && formData.actualAmountOfEligibleDivinends !== null ?
            parseFloat(
              formData.actualAmountOfEligibleDivinends.replace(/[$,]/g, '')
            ) : 0,
          capitalGains: formData.capitalGains && formData.capitalGains !== null ?
            parseFloat(
              formData.capitalGains.replace(/[$,]/g, '')
            ) : 0,
          capitalGainsEligible: formData.capitalGainsEligible && formData.capitalGainsEligible !== null ?
            parseFloat(formData.capitalGainsEligible.replace(/[$,]/g, '')) : 0,
          actualAmountOtherThanEligible: formData.actualAmountOtherThanEligible && formData.actualAmountOtherThanEligible !== null ?
            parseFloat(
              formData.actualAmountOtherThanEligible.replace(/[$,]/g, '')
            ) : 0,
          otherIncome: formData.otherIncome && formData.otherIncome !== null ?
            parseFloat(
              formData.otherIncome.replace(/[$,]/g, '')
            ) : 0,
          optionalTextToPrintOnTheSlip: formData.optionalTextToPrintOnTheSlip !== '' ? formData.optionalTextToPrintOnTheSlip : undefined,
          footNotes: formData.footNotes !== '' ? formData.footNotes : undefined,
        },
        // secondExternalId:
        //   formData.recipientType === 20 &&
        //   selectedSecondRecipientResourceActualIdValue && selectedSecondRecipientResourceActualIdValue?.resourceId
        //     ? selectedSecondRecipientResourceActualIdValue.resourceId
        //     : undefined,
      };


      // submitFlexFields(formData);
      submitFlexFields(requestPayload);
    }
  };

  const onResetClicked = () => {
    setSnackbarData({
      open: true,
      message: "Form was reset successfully",
      severity: "success",
    });
    formMethods.reset();
    formMethods.setValue("comparison", [{ amount: 0, code: "", label: "" }]);
    setSlipOtherInformation([])
    setSelectedResourceSlipList([{ label: "Create New", value: "create-new" }]);
    setSelectedResourceSlip("create-new");
    setSelectedOtherInformation(false);
    setSelectedResource("create-new");
    setSelectedCard(null);
    let path = `/taxslip/t3/setup`;
    navigate(path);
    setT3SlipRecord(undefined);
  };

  // For Delete Row

  const { isPending: isDeleting, mutate: deleteT3SlipById } = useMutation({
    mutationFn: T3SlipService.delT3Slip,

    onSuccess: (res: any | IServerError | IResponse) => {

      if (typeof res === "string") {
        // remove the cache of the Year fields since we just added a new field.
        setSnackbarData({
          open: true,
          message: "Record has been deleted successfully.",
          severity: "success",
        });
        setT3SlipRecord(undefined);
        // refectchT3SlipIds()
      } else {
        setSnackbarData({
          open: true,
          // message: "Something went wrong, try again later!",
          message: res.message,
          severity: "error",
        });
      }

      //load Employee Data
      if (res) {
        const selectedVendor = formMethods.getValues("selectedVendor");

        if (selectedVendor !== "create-new") {
          (async () => {
            try {
              let path = `/taxslip/t3/setup/${selectedVendor}`;
              navigate(path);
              const fetchData = async () => {
                try {
                  const response: any =
                    await T3SlipService.getResourceSlipDropDownList(
                      selectedVendor,
                      clientId,
                      taxYear
                    );

                  if (response && Array.isArray(response)) {
                    let resourceSlipList: IDropDownListResponse[] =
                      response.map((resourceSlip: IDropDownListResponse) => ({
                        label: resourceSlip.label,
                        value: resourceSlip.value,
                      }));

                    resourceSlipList.unshift({
                      label: "Create New",
                      value: "create-new",
                    });


                    setSelectedResourceSlipList(resourceSlipList);
                    formMethods.setValue(
                      "selectedSlip",
                      resourceSlipList[0].value
                    );
                    createNewActionFromSlipDDL();
                  }
                } catch (error) {
                  console.error("Error fetching data:", error);
                }
              };

              fetchData();
            } catch (err) {
            }
          })();
        }
      }
      selectedT3SlipType = formMethods.getValues("slipType");
      setSelectedOtherInformation(true);
    },
    onError: (err: any) => {
      setSnackbarData({
        open: true,
        message: err.message,
        severity: "error",
      });
    },
  }
  );

  const deleteT3SlipField = () => {
    if (singleDelete) {
      let payload = {
        t3SlipId,
        clientId,
        taxYear,
      };
      setSingleDelete(false);
      deleteT3SlipById(payload);
      setDialogOpen(false);
    }
  };

  const onDeleteClicked = () => {
    setDialogOpen(true);
    setSingleDelete(true);
    setApiAction("delete");
    if (
      selectedT3SlipsData &&
      selectedT3SlipsData.resource
    ) {
      setT3SlipId(selectedT3SlipsData.id);
    }
  };

  const savePdfAsFile = (pdfData: any, filename: any) => {
    const blob = new Blob([pdfData], { type: "pdf;charset=utf-8" });
    FileSaver.saveAs(blob, filename);
  };
  const onPrintClicked = async (printType: any): Promise<void> => {
    setIsLoadingData(true);
    // const maskedStatus: any = sessionStorage.getItem("maskEnabled");
    if (dashboardApiData.masked_status) {
      setIsLoadingData(false);
      setSnackbarData({
        open: true,
        message: "Please unmask your data.",
        severity: "error",
      });
    } else {
      if (invoicePaymentFor === 10) {
        try {
          const previousYearInvoiceResponse: any = await ReportsService.getPreviousYearInvoice(
            clientId,
            taxYear - 1
          );
          try {
            const response: any = await ReportsService.createInvoice(
              clientId,
              taxYear
            );
            setIsLoadingData(false);
            if (previousYearInvoiceResponse.message === "Slips not found for invoice." && response.message === "Slips not found for invoice.") {
              try {
                const t3SlipIdsAndAuditStatus: any =
                  await T4SlipService.getSlipIds("T3", clientId, taxYear);
                if (t3SlipIdsAndAuditStatus && t3SlipIdsAndAuditStatus.generalAuditStatus !== null && t3SlipIdsAndAuditStatus.generalAuditStatus === true &&
                  t3SlipIdsAndAuditStatus && t3SlipIdsAndAuditStatus.auditStatus !== null && t3SlipIdsAndAuditStatus.auditStatus === true) {
                  setIsLoadingData(true);
                  try {
                    const jsonString = formMethods.getValues("province")
                      ? formMethods.getValues("province")
                      : ('{id:9, name: "Ontario",shortCode:"ON"}' as string);
                    const ProvinceOfEmploymentData =
                      parseJSONLikeString(jsonString);
                    // const response: any = await PrintingService.createSingleT3PdfPrint(clientId, editedResourceId, formMethods.getValues("slipType"), printType, ProvinceOfEmploymentData.shortCode, taxYear);
                    let pdfIds = `t3_slip_ids=${id}`;
                    const response: any =
                      await PrintingService.createBulkT3PdfPrint(
                        clientId,
                        printType === "Recipient"
                          ? "20"
                          : "10",
                        pdfIds,
                        taxYear
                      );
                    if (response.status === 400) {
                      setSnackbarData({
                        open: true,
                        message: response.data.message
                          ? response.data.message
                          : "Something went wrong.",
                        // message: "Please Unmask sensitive data for PDF printing.",
                        severity: "error",
                      });
                    } else {
                      const filename = `T3slip-${clientName}-${printType}.pdf`;
                      savePdfAsFile(response, filename);
                    }
                    setIsLoadingData(false);
                  } catch (err) {

                    alert(err);
                  }
                  // }
                  setIsLoadingData(false);
                } else {
                  setIsLoadingData(false);
                  setSnackbarData({
                    open: true,
                    message: (
                      <>
                        Please load Audit in the menu, press Run T3 Audit and clear all audit items to generate documents.{" "}
                        <a
                          href="https://appv3.taxslips.com/#/audit/filing"
                          style={{
                            color: "#aa1010",
                            textDecoration: "none",
                            fontWeight: "bold",
                          }}
                        >
                          Click here to view
                        </a>
                      </>
                    ),
                    severity: "error",
                    autoHide: false,
                  });
                }
              } catch (err: any) {
                setIsLoadingData(false);
              }
            } else if (
              response?.id != null &&
              previousYearInvoiceResponse?.id != null
            ) {

              setInvoiceData([previousYearInvoiceResponse, response]);
              setInvoiceDialogOpen(true);
            } else if (
              previousYearInvoiceResponse?.id != null &&
              response?.message === "Slips not found for invoice."
            ) {

              setInvoiceData([previousYearInvoiceResponse]);
              setInvoiceDialogOpen(true);
            } else if (
              response?.id != null &&
              previousYearInvoiceResponse?.message === "Slips not found for invoice."
            ) {

              setInvoiceData([response]);
              setInvoiceDialogOpen(true);
            } else {
              setSnackbarData({
                open: true,
                message: "Something went wrong.",
                severity: "error",
              });
            }
            setIsLoadingData(false);
          } catch (err) {

            setIsLoadingData(false);
          }
        } catch (err) {

          setIsLoadingData(false);
        }
      } else {
        try {
          const response: any = await ReportsService.createInvoice(
            clientId,
            taxYear
          );
          setIsLoadingData(false);

          if (response.message === "Slips not found for invoice.") {
            // setIsLoadingData(true);
            // try {
            //   const filingAuditResponse: any =
            //     await T3SlipService.getT3AuditFiling(clientId, taxYear);
            //   
            //   if (
            //     filingAuditResponse &&
            //     filingAuditResponse.general_filling &&
            //     filingAuditResponse.general_filling.length > 0
            //   ) {
            //    
            //     setSnackbarData({
            //       open: true,
            //       message: (
            //         <>
            //           Please load Audit in the menu and clear all audit items
            //           (Audit Filing and PIER Review) to generate documents.{" "}
            //           <a
            //             href="https://appv3.taxslips.com/#/audit/filing"
            //             style={{
            //               color: "#aa1010",
            //               textDecoration: "none",
            //               fontWeight: "bold",
            //             }}
            //           >
            //             Click here to view
            //           </a>
            //         </>
            //       ),
            //       severity: "error",
            //       autoHide: false,
            //     });
            //   } else if (
            //     filingAuditResponse &&
            //     filingAuditResponse.t3_filling &&
            //     filingAuditResponse.t3_filling.length > 0
            //   ) {
            //   
            //     setSnackbarData({
            //       open: true,
            //       message: (
            //         <>
            //           Please load Audit in the menu and clear all audit items
            //           (Audit Filing and PIER Review) to generate documents.{" "}
            //           <a
            //             href="https://appv3.taxslips.com/#/audit/filing"
            //             style={{
            //               color: "#aa1010",
            //               textDecoration: "none",
            //               fontWeight: "bold",
            //             }}
            //           >
            //             Click here to view
            //           </a>
            //         </>
            //       ),
            //       severity: "error",
            //       autoHide: false,
            //     });
            //   } else {
            //     setIsLoadingData(true);
            try {
              const t3SlipIdsAndAuditStatus: any =
                await T4SlipService.getSlipIds("T3", clientId, taxYear);
              if (t3SlipIdsAndAuditStatus && t3SlipIdsAndAuditStatus.generalAuditStatus !== null && t3SlipIdsAndAuditStatus.generalAuditStatus === true &&
                t3SlipIdsAndAuditStatus && t3SlipIdsAndAuditStatus.auditStatus !== null && t3SlipIdsAndAuditStatus.auditStatus === true) {
                setIsLoadingData(true);
                try {
                  const jsonString = formMethods.getValues("province")
                    ? formMethods.getValues("province")
                    : ('{id:9, name: "Ontario",shortCode:"ON"}' as string);
                  const ProvinceOfEmploymentData =
                    parseJSONLikeString(jsonString);
                  // const response: any = await PrintingService.createSingleT3PdfPrint(clientId, editedResourceId, formMethods.getValues("slipType"), printType, ProvinceOfEmploymentData.shortCode, taxYear);
                  let pdfIds = `t3_slip_ids=${id}`;
                  const response: any =
                    await PrintingService.createBulkT3PdfPrint(
                      clientId,
                      printType === "Recipient"
                        ? "20"
                        : "10",
                      pdfIds,
                      taxYear
                    );
                  if (response.status === 400) {
                    setSnackbarData({
                      open: true,
                      message: response.data.message
                        ? response.data.message
                        : "Something went wrong.",
                      // message: "Please Unmask sensitive data for PDF printing.",
                      severity: "error",
                    });
                  } else {
                    const filename = `T3slip-${clientName}-${printType}.pdf`;
                    savePdfAsFile(response, filename);
                  }
                  setIsLoadingData(false);
                } catch (err) {

                  alert(err);
                }
                // }
                setIsLoadingData(false);
              } else {
                setIsLoadingData(false);
                setSnackbarData({
                  open: true,
                  message: (
                    <>
                      Please load Audit in the menu, press Run T3 Audit and clear all audit items to generate documents.{" "}
                      <a
                        href="https://appv3.taxslips.com/#/audit/filing"
                        style={{
                          color: "#aa1010",
                          textDecoration: "none",
                          fontWeight: "bold",
                        }}
                      >
                        Click here to view
                      </a>
                    </>
                  ),
                  severity: "error",
                  autoHide: false,
                });
              }
            } catch (err: any) {
              setIsLoadingData(false);
            }
          } else if (response && response.id !== null) {
            setInvoiceData([response]);
            setInvoiceDialogOpen(true);
          } else {
            setSnackbarData({
              open: true,
              message: "Something went wrong.",
              severity: "error",
            });
          }
        } catch (err) {

          setIsLoadingData(false);
        }
      }
    }
  };

  const onUnPaidClickHandler = (clickedRow: any, tag: string) => {
    setIsLoadingData(true);
    // setTimeout(() => {
    //   setIsLoadingData(false);
    // }, 2500);
    const fetchData = async () => {
      try {
        const response: any =
          await ReportsService.paypalIntegrationOfUnpaidInvoice(
            clientId,
            clickedRow.refNo,
            tag
          );
        setIsLoadingData(false);

        if (tag === 'paypal') {
          window.open(response, '_blank');
        } else {
          window.open(response.message, '_blank');
        }
      } catch (error) {
        setIsLoadingData(false);
        console.error("Error fetching data:", error);
      } finally {
        setIsLoadingData(false);
      }
    }
    fetchData();

  };

  const onClickInvoiceNoHandler = (clickedRow: any) => {
    dispatch(setSelectedINVOICE(clickedRow));

  };
  /**
   * On Snackbar closed.
   *
   * @param {React.SyntheticEvent | Event} event
   * @param {string} reason
   */
  const onSnackbarClosed = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarData(INITIAL_SNACKBAR_DATA);
  };

  const onResourceSelectionChangeHandler = async (
    selectedItem: IEnhancedDropDownItem | any,
    index?: any
  ): Promise<void> => {
    //this is for card selection
    setSelectedCard(index);
    setSelectedResourceSlip("create-new");
    if (!index) {
      //this is for card selection
      setSelectedCard(selectedItem.value);
      setSelectedResourceSlip("create-new");
    }
    if (selectedItem.value === "create-new") {
      setSnackbarData({
        open: true,
        message: "Please load a payee for T3 Slip",
        severity: "error",
      });
      setSidePanelsVisibility((prevButtonState: any) => !prevButtonState);
      formMethods.reset();
      formMethods.setValue("comparison", [{ amount: 0, code: "", label: "" }]);
      setSlipOtherInformation([])
      setSelectedResourceSlipList([
        { label: "Create New", value: "create-new" },
      ]);
      setSelectedOtherInformation(false);
      setSelectedResourceSlip("create-new");
      let path = `/taxslip/t3/setup`;
      navigate(path);
      setT3SlipRecord(undefined);
      setSelectedResource("create-new");
      // const fetchData = async () => {
      //   try {
      //     setIsLoadingAdjustedData(true);
      //     const response: any = await T3SlipService.getT3RecipientDDLByRecipientType(
      //       clientId,
      //       T3_BENEFICIARY_RESOURCE_LITERAL,
      //       taxYear,
      //       10
      //     );
      //     if (response && Array.isArray(response)) {
      //       let resources: IDropDownListResponse[] = response.map(
      //         (resourceItem: IDropDownListResponse) => ({
      //           label: resourceItem.label,
      //           value: resourceItem.value,
      //         })
      //       );
      //       resources.unshift({
      //         label: "Create New",
      //         value: "create-new",
      //       });
      //       setSelectedResourceList(resources);
      //     }
      //     setResourceListWithoutCreateNew(sortData(response));
      //   } catch (error) {
      //     console.error("Error fetching data:", error);
      //     setIsLoadingAdjustedData(false);
      //   } finally {
      //     setIsLoadingAdjustedData(false);
      //   }
      // };
      // fetchData();
      // queryClient.invalidateQueries({
      //   queryKey: [T3_RECIPIENT_DDL_DATA_QUERY_KEY, clientId,
      //     T3_BENEFICIARY_RESOURCE_LITERAL,
      //     taxYear,
      //     10],
      // });
      // queryClient.invalidateQueries({
      //   queryKey: [T3_RECIPIENT_DDL_DATA_QUERY_KEY, clientId, T3_BENEFICIARY_RESOURCE_LITERAL, taxYear],
      // });
    } else {
      // formMethods.reset();
      // setOnResourceSelectionAPIsCalls(true);
      setOnResourceSelectionAPIsCalls(true);
      formMethods.setValue(
        "selectedEmployee",
        selectedItem.value
      );
      setSelectedResource(selectedItem.value);
      (async () => {
        setIsPendingSlipData(true)
        try {
          formMethods.setValue(
            "selectedVendor",
            selectedItem.value
          );

          (async () => {
            setIsPendingSlipData(true)
            try {
              const response: any =
                await T3SlipService.getResourceSlipDropDownList(
                  selectedItem.value,
                  clientId,
                  taxYear
                );

              // formMethods.setValue("selectedSlip", response[0].value);

              if (response && Array.isArray(response)) {
                let resourceSlipList: IDropDownListResponse[] =
                  response.map(
                    (resourceSlip: IDropDownListResponse) => ({
                      label: resourceSlip.label,
                      value: resourceSlip.value,
                    })
                  );

                resourceSlipList.unshift({
                  label: "Create New",
                  value: "create-new",
                });


                setSelectedResourceSlipList(resourceSlipList);
                if (
                  resourceSlipList &&
                  resourceSlipList.length > 1
                ) {
                  (async () => {
                    try {

                      setIsPendingSlipData(true);
                      let slipDataById =
                        await T3SlipService.getT3SlipById(
                          String(resourceSlipList[1].value),
                          clientId,
                          taxYear
                        );
                      setT3SlipRecord(slipDataById)
                      setSelectedResourceSlip(
                        String(resourceSlipList[1].value)
                      );
                      formMethods.setValue(
                        "selectedSlip",
                        String(resourceSlipList[1].value)
                      );
                      slipDataByIdPass(slipDataById, true);

                      //set slip type to 400 because when we come back to slip without reload it will automatically be original
                      selectedT3SlipType =
                        formMethods.getValues("slipType");
                      setSelectedOtherInformation(false);
                    } catch (error) {
                      setIsPendingSlipData(false);
                      console.error(
                        "Error fetching data:",
                        error
                      );
                    }
                  })();
                } else {
                  (async () => {
                    try {
                      setIsPendingSlipData(true);
                      let resourceDataById =
                        await T3SlipService.getResourceInformationById(
                          selectedItem.value,
                          clientId,
                          T3_BENEFICIARY_RESOURCE_LITERAL
                        );

                      resourceDataByIdPass(resourceDataById)
                    } catch (error) {
                      setIsPendingSlipData(false);
                      console.error("Error fetching data:", error);
                    }
                  })();
                  setT3SlipRecord(undefined)
                  setSelectedResourceSlip("create-new");
                  // createNewActionFromSlipDDL()
                  setSelectedResource(
                    String(
                      selectedItem.value
                    )
                  );
                  setEditedResourceId(
                    String(
                      selectedItem.value
                    )
                  );
                  let path = `/taxslip/t3/setup/${selectedItem.value}`;
                  navigate(path);
                }
              }
            } catch (error) {
              setIsPendingSlipData(false)
              console.error("Error fetching data:", error);
            }
          })();
          // You can work with the data here or trigger other functions that depend on the fetched data
          //   } catch (error) {
          //     console.error("Error fetching data:", error);
          //   }
          // })();
        } catch (error) {
          setIsPendingSlipData(false)
          console.error("Error fetching data:", error);
        }
      })();



    }
    setSelectedOtherInformation(false);
  };

  const onResourceSlipSelectionChangeHandler = (
    selectedItem: IEnhancedDropDownItem | any
  ) => {
    setOnResourceSelectionAPIsCalls(true);

    if (selectedItem.value === "create-new") {
      createNewActionFromSlipDDL();
      setSelectedResourceSlip("create-new");
      if (selectedResource !== "create-new") {
        setOnResourceSelectionAPIsCalls(true);
        let path = `/taxslip/t3/setup/${selectedResource}`;
        navigate(path);
      }
      setT3SlipRecord(undefined);
    }
    if (selectedItem.value !== "create-new") {
      (async () => {
        try {
          setIsLoadingAdjustedData(true);
          let slipDataById = await T3SlipService.getT3SlipById(
            String(selectedItem.value),
            clientId,
            taxYear
          );
          setT3SlipRecord(slipDataById)
          slipDataByIdPass(slipDataById, true);
          selectedT3SlipType = formMethods.getValues("slipType");
          setSelectedOtherInformation(false);
          setIsLoadingAdjustedData(false);
        } catch (error) {
          setIsLoadingAdjustedData(false);
          console.error("Error fetching data:", error);
        }
      })();
    }
    setSelectedOtherInformation(true);
  };

  // const { isPending: isLoadingGlobalVariables, data: editDataRecord } =
  //   useGetGlobalVariables(taxYear);
  // const globalVariablesData: any = editDataRecord;

  // const { isPending: loadingSlipIds, data: t3SlipIds, refetch: refectchT3SlipIds } = useGetSlipIds("T3", clientId, taxYear);
  // const { isPending: isLoadingClientDataById, data: companyGetByIdRecord } =
  //   useGetCompanyData(clientId);

  useEffect(() => {

    if (dashboardApiData && dashboardApiData.client_detail && dashboardApiData.client_detail && dashboardApiData.client_detail.metaFields) {
      const paymentFor = dashboardApiData.client_detail.metaFields.find((item: any) => item.name === 'invoice_payment_for')

      setInvoicePaymentFor(paymentFor ? parseInt(paymentFor.value) : 10)
    }
  }, [dashboardApiData])



  // for edit

  //if slip is completed this will effected
  useEffect(() => {
    // if the selected flex field data has loaded.
    if (T3SlipRecord && onResourceSelectionAPIsCalls === false) {
      slipDataByIdPass(T3SlipRecord, onResourceSelectionAPIsCalls);
    }
    selectedT3SlipType = formMethods.getValues("slipType");
    setSelectedOtherInformation(false);
    if (!id && !T3SlipRecord) {
      formMethods.setValue("comparison", [{ amount: 0, code: "", label: "" }]);
    }
  }, [T3SlipRecord, formMethods.setValue, formMethods, onResourceSelectionAPIsCalls]);

  //this is for not started slip
  useEffect(() => {
    // if the selected flex field data has loaded.
    if (selectedNotStartedResourceData && onResourceSelectionAPIsCalls === false) {
      resourceDataByIdPass(selectedNotStartedResourceData);
    }
  }, [selectedNotStartedResourceData, formMethods.setValue, formMethods, onResourceSelectionAPIsCalls]);

  // useEffect(() => {
  //   //Load T3 Recipient DDL
  //   if (T3SlipRecord) {
  //     // const fetchData = async () => {
  //     //   try {
  //     //     setIsLoadingAdjustedData(true);
  //     //     const response: any =
  //     //       await T3SlipService.getT3RecipientDDLByRecipientType(
  //     //         clientId,
  //     //         T3_BENEFICIARY_RESOURCE_LITERAL,
  //     //         taxYear,
  //     //         T3SlipRecord.recipientType
  //     //       );
  //     //     if (response && Array.isArray(response)) {
  //     //       let resources: IDropDownListResponse[] = response.map(
  //     //         (resourceItem: IDropDownListResponse) => ({
  //     //           label: resourceItem.label,
  //     //           value: resourceItem.value,
  //     //         })
  //     //       );
  //     //       resources.unshift({
  //     //         label: "Create New",
  //     //         value: "create-new",
  //     //       });
  //     //       setSelectedResourceList(resources);
  //     //     }
  //     //     setResourceListWithoutCreateNew(sortData(response));
  //     //   } catch (error) {
  //     //     console.error("Error fetching data:", error);
  //     //     setIsLoadingAdjustedData(false);
  //     //   } finally {
  //     //     setIsLoadingAdjustedData(false);
  //     //   }
  //     // };
  //     // fetchData();
  //     console.log('T3SlipRecord.recipientType',T3SlipRecord.recipientType)
  //     queryClient.invalidateQueries({
  //       queryKey: [T3_RECIPIENT_DDL_DATA_QUERY_KEY, clientId,
  //         T3_BENEFICIARY_RESOURCE_LITERAL,
  //         taxYear,
  //         Number(T3SlipRecord.recipientType)],
  //     });
  //   } else if (selectedNotStartedResourceData) {
  //     selectedNotStartedResourceData?.metaFields.forEach((field: any) => {
  //       if (field.name === "recipientType") {
  //         let recipientTypeValue = parseInt(field.value);
  //         // const fetchData = async () => {
  //         //   try {
  //         //     setIsLoadingAdjustedData(true);
  //         //     const response: any =
  //         //       await T3SlipService.getT3RecipientDDLByRecipientType(
  //         //         clientId,
  //         //         T3_BENEFICIARY_RESOURCE_LITERAL,
  //         //         taxYear,
  //         //         recipientTypeValue
  //         //       );
  //         //     if (response && Array.isArray(response)) {
  //         //       let resources: IDropDownListResponse[] = response.map(
  //         //         (resourceItem: IDropDownListResponse) => ({
  //         //           label: resourceItem.label,
  //         //           value: resourceItem.value,
  //         //         })
  //         //       );
  //         //       resources.unshift({
  //         //         label: "Create New",
  //         //         value: "create-new",
  //         //       });
  //         //       setSelectedResourceList(resources);
  //         //     }
  //         //     setResourceListWithoutCreateNew(sortData(response));
  //         //   } catch (error) {
  //         //     console.error("Error fetching data:", error);
  //         //     setIsLoadingAdjustedData(false);
  //         //   } finally {
  //         //     setIsLoadingAdjustedData(false);
  //         //   }
  //         // };
  //         // fetchData();
  //         queryClient.invalidateQueries({
  //           queryKey: [T3_RECIPIENT_DDL_DATA_QUERY_KEY, clientId,
  //             T3_BENEFICIARY_RESOURCE_LITERAL,
  //             taxYear,
  //             recipientTypeValue],
  //         });
  //       }
  //     });
  //   }
  //   // else {
  //   // const recipientType = formMethods.getValues("recipientType");
  //   // const fetchData = async () => {
  //   //   try {
  //   //     setIsLoadingAdjustedData(true);
  //   //     const response: any = await T3SlipService.getT3RecipientDDLByRecipientType(
  //   //       clientId,
  //   //       T3_BENEFICIARY_RESOURCE_LITERAL,
  //   //       taxYear,
  //   //       recipientType
  //   //     );
  //   //     if (response && Array.isArray(response)) {
  //   //       let resources: IDropDownListResponse[] = response.map(
  //   //         (resourceItem: IDropDownListResponse) => ({
  //   //           label: resourceItem.label,
  //   //           value: resourceItem.value,
  //   //         })
  //   //       );
  //   //       resources.unshift({
  //   //         label: "Create New",
  //   //         value: "create-new",
  //   //       });
  //   //       setSelectedResourceList(resources);
  //   //     }
  //   //     setResourceListWithoutCreateNew(sortData(response));
  //   //   } catch (error) {
  //   //     console.error("Error fetching data:", error);
  //   //     setIsLoadingAdjustedData(false);
  //   //   } finally {
  //   //     setIsLoadingAdjustedData(false);
  //   //   }
  //   // };
  //   // fetchData();
  //   // queryClient.invalidateQueries({
  //   //   queryKey: [T3_RECIPIENT_DDL_DATA_QUERY_KEY, clientId,
  //   //     T3_BENEFICIARY_RESOURCE_LITERAL,
  //   //     taxYear,
  //   //     recipientType],
  //   // });
  //   // }
  // }, [T3SlipRecord, selectedNotStartedResourceData, formMethods]);

  // when  I formMethods.setValue of otherinformation inside async calls method then facing issue while click on add more so we have to use state method to show otherinformation 
  useEffect(() => {

    if (
      slipOtherInformation &&
      slipOtherInformation !== null &&
      slipOtherInformation.length !== 0
    ) {

      setOiInEdit(true);
      formMethods.setValue(
        "comparison",
        slipOtherInformation
      );
    } else if (!id) {

      setOiInEdit(true);
      formMethods.setValue(
        "comparison",
        [
          {
            amount: 0,
            code: "",
            label: "",
          },
        ]
      );
    }
  }, [slipOtherInformation])

  const onSlipTypeSelectionChangeHandler = (e: any) => {
    setIsLoadingAdjustedData(true);
    setTimeout(() => {
      setIsLoadingAdjustedData(false);
    }, 1000);
    const selectedType = e.value;
    selectedT3SlipType = selectedType;
    // alert(selectedType);
  };

  const onCloseHandler = () => {
    setDialogOpen(false);
    setInvoiceDialogOpen(false);
  };



  const getCardStyles = (index: any) => {
    return {
      borderLeft:
        selectedCard === index ? "6px solid #0057db" : "2px solid transparent",
      cursor: "pointer",
    };
  };
  const getSelectedResourceSlipInCard = (index: any) => {
    let selectedItem =
      selectedCard === index ? selectedResourceSlip : "create-new";
    return selectedItem;
  };
  const getSelectedResourceSlipsListInCard = (index: any) => {
    let selectedList =
      selectedCard === index
        ? selectedResourceSlipList
        : [{ label: "Create New", value: "create-new" }];
    return selectedList;
  };

  const filteredResourceList =
    resourceListWithoutCreateNew &&
    resourceListWithoutCreateNew.filter((item: any) =>
      item.label.toLowerCase().includes(itemSearch.toLowerCase())
    );

  const onCreateNewButtonClicked = () => {
    setSnackbarData({
      open: true,
      message: "Please load a payee for T3 Slip",
      severity: "error",
    });
    formMethods.reset();
    formMethods.setValue("comparison", [{ amount: 0, code: "", label: "" }]);
    setSlipOtherInformation([])
    setSelectedResourceSlipList([{ label: "Create New", value: "create-new" }]);
    setSelectedResourceSlip("create-new");
    let path = `/taxslip/t3/setup`;
    navigate(path);
    setT3SlipRecord(undefined);
    setIsLoadingAdjustedData(true);
    setTimeout(() => {
      setIsLoadingAdjustedData(false);
    }, 1000);
    setSelectedResource("create-new");
    setSelectedCard(null);
    // const fetchData = async () => {
    //   try {
    //     setIsLoadingAdjustedData(true);
    //     const response: any = await T3SlipService.getT3RecipientDDLByRecipientType(
    //       clientId,
    //       T3_BENEFICIARY_RESOURCE_LITERAL,
    //       taxYear,
    //       10
    //     );
    //     if (response && Array.isArray(response)) {
    //       let resources: IDropDownListResponse[] = response.map(
    //         (resourceItem: IDropDownListResponse) => ({
    //           label: resourceItem.label,
    //           value: resourceItem.value,
    //         })
    //       );
    //       resources.unshift({
    //         label: "Create New",
    //         value: "create-new",
    //       });
    //       setSelectedResourceList(resources);
    //     }
    //     setResourceListWithoutCreateNew(sortData(response));
    //   } catch (error) {
    //     console.error("Error fetching data:", error);
    //     setIsLoadingAdjustedData(false);
    //   } finally {
    //     setIsLoadingAdjustedData(false);
    //   }
    // };
    // fetchData();
    // queryClient.invalidateQueries({
    //   queryKey: [T3_RECIPIENT_DDL_DATA_QUERY_KEY, clientId,
    //     T3_BENEFICIARY_RESOURCE_LITERAL,
    //     taxYear,
    //     10],
    // });
    queryClient.invalidateQueries({
      queryKey: [T3_RECIPIENT_DDL_DATA_QUERY_KEY, clientId, T3_BENEFICIARY_RESOURCE_LITERAL, taxYear],
    });
  };
  const onDividerButtonClickHandler = () => {
    setSidePanelsVisibility((prevButtonState: any) => !prevButtonState);
  };
  const onIndividualSelectionChangeHandler = (value: boolean) => {
    formMethods.setValue("secondRecipientName", undefined);
    if (value === true) {
      (async () => {
        try {
          setIsLoadingAdjustedData(true);
          const response: any =
            await T3SlipService.getT3RecipientDDLByRecipientType(
              clientId,
              T3_BENEFICIARY_RESOURCE_LITERAL,
              taxYear,
              10
            );

          setSecondRecipientDDL(response);
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setIsLoadingAdjustedData(false);
        }
      })();
      // queryClient.invalidateQueries({
      //   queryKey: [T3_RECIPIENT_DDL_DATA_QUERY_KEY, clientId,
      //     T3_BENEFICIARY_RESOURCE_LITERAL,
      //     taxYear,
      //     10],
      // });
    } else if (value === false) {
      (async () => {
        try {
          setIsLoadingAdjustedData(true);
          const response: any =
            await T3SlipService.getT3RecipientDDLByRecipientType(
              clientId,
              T3_BENEFICIARY_RESOURCE_LITERAL,
              taxYear,
              30
            );

          setSecondRecipientDDL(response);
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setIsLoadingAdjustedData(false);
        }
      })();
      // queryClient.invalidateQueries({
      //   queryKey: [T3_RECIPIENT_DDL_DATA_QUERY_KEY, clientId,
      //     T3_BENEFICIARY_RESOURCE_LITERAL,
      //     taxYear,
      //     30],
      // });
    }
  };
  // useEffect(() => {
  //   const recipientType = formMethods.getValues("recipientType");
  //   const individual = formMethods.getValues("individual");

  //     if (individual === false) {
  //       (async () => {
  //         try {
  //           setIsLoadingAdjustedData(true);
  //           const response: any =
  //             await T3SlipService.getT3RecipientDDLByRecipientType(
  //               clientId,
  //               T3_BENEFICIARY_RESOURCE_LITERAL,
  //               taxYear,
  //               30
  //             );

  //           setSecondRecipientDDL(response);
  //         } catch (error) {
  //           console.error("Error fetching data:", error);
  //         } finally {
  //           setIsLoadingAdjustedData(false);
  //         }
  //       })();
  //       // queryClient.invalidateQueries({
  //       //   queryKey: [T3_RECIPIENT_DDL_DATA_QUERY_KEY, clientId,
  //       //     T3_BENEFICIARY_RESOURCE_LITERAL,
  //       //     taxYear,
  //       //     30],
  //       // });
  //     } else if (individual === true) {
  //       (async () => {
  //         try {
  //           setIsLoadingAdjustedData(true);
  //           const response: any =
  //             await T3SlipService.getT3RecipientDDLByRecipientType(
  //               clientId,
  //               T3_BENEFICIARY_RESOURCE_LITERAL,
  //               taxYear,
  //               10
  //             );

  //           setSecondRecipientDDL(response);
  //         } catch (error) {
  //           console.error("Error fetching data:", error);
  //         } finally {
  //           setIsLoadingAdjustedData(false);
  //         }
  //       })();
  //       // queryClient.invalidateQueries({
  //       //   queryKey: [T3_RECIPIENT_DDL_DATA_QUERY_KEY, clientId,
  //       //     T3_BENEFICIARY_RESOURCE_LITERAL,
  //       //     taxYear,
  //       //     10],
  //       // });
  //     }
  // }, [formMethods]);

  // let foreignCurrencyDDL = [
  //   {
  //     label: "AFG",
  //     value: "AFG",
  //     name: "Afghanistan",
  //   },
  //   {
  //     label: "CAN",
  //     value: "CAN",
  //     name: "Canada",
  //   },
  //   {
  //     label: "PAK",
  //     value: "PAK",
  //     name: "Pakistan",
  //   },
  // ];

  // useEffect(() => {
  //   const recipientType = formMethods.getValues("recipientType");

  //   setRecipientTypeValue(recipientType);
  // }, [formMethods]);


  useEffect(() => {
    dispatch(
      setSelectedActivityLogActions({
        entityId1: id ? id : "",
        entityId2: "",
        entityId3: "",
        screenName: T3_SETUP_SCREEN_SLUG,
        companyName: clientName,
        activityType: "activity_type=create&activity_type=updated&activity_type=print&activity_type=delete",
        activityLogVisibility: true,
      })
    );
    dispatch(setSelectedStickyNavBar({ isSticky: true }));
  }, []);
  return (
    <>
      <Grid
        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
        sx={{
          pb: "5rem",
          "& .MuiAppBar-root": { zIndex: 2, top: "65px" },
          "& .p-datepicker": { zIndex: 2 },
          paddingTop: "2rem",
        }}
      >
        <BackdropCircularProgress
          open={
            isSubmitting ||
            isLoadingData ||
            isLoadingAdjustedData ||
            isDeleting ||
            isLoadingNotStartedSlipId ||
            isLoadingDataa ||
            isPendingEmployeeDDLItems ||
            isLoadingActivityLogData
          }
          testId={testId}
        />
        <DeleteConfirmationDialog
          open={openDialog}
          deleteActionHandler={deleteT3SlipField}
          cancelActionHandler={onCloseHandler}
          testId="T4-confirmation-dialog"
        />
        <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
          {sidePanelsVisibility && (
            <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
              <Box sx={{ margin: "0" }}>
                <InputText
                  value={itemSearch}
                  onChange={(e) => setItemSearch(e.target.value)}
                  placeholder={"Search by name..."}
                  className="w-full search-field"
                />
                <Box sx={{ display: "flex", justifyContent: "end" }}>
                  <Button
                    variant="contained"
                    sx={{ right: 0, margin: "10px 0px", fontSize: "12px" }}
                    onClick={onCreateNewButtonClicked}
                  >
                    + Create New
                  </Button>
                </Box>
              </Box>
              <Box
                sx={{
                  // display: "flex",
                  height: "68rem",
                  // flexDirection: "column",
                  overflow: "auto",
                  "&::-webkit-scrollbar": {
                    width: "0.4em",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#ccc",
                    borderRadius: "3px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "#aaa",
                  },
                }}
              >
                {resourceListWithoutCreateNew &&
                  filteredResourceList.map((item: any, index: any) => {
                    return (
                      <Card
                        sx={{
                          padding: 0,
                          borderRadius: "8px",
                          marginBottom: "1rem",
                        }}
                        key={index}
                        onClick={() =>
                          onResourceSelectionChangeHandler(item, item.value)
                        }
                        style={getCardStyles(item.value)}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "0.8rem",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            sx={{ fontWeight: "bold", fontSize: ".875rem" }}
                          >
                            {item.label}
                          </Typography>
                          <Avatar
                            shape="circle"
                            style={{
                              background: "#0057db",
                              color: "#fff",
                              borderRadius: "50%",
                              fontWeight: "bold",
                              fontSize: ".775rem",
                              padding: "2px",
                            }}
                          >
                            {item.label
                              .replace(/\s+/g, " ")
                              .split(" ")
                              .filter((word: string) => word.trim() !== "")
                              .map((word: string) => word[0].toUpperCase())
                              .slice(0, 2)
                              .join("")}
                          </Avatar>
                        </Box>
                        {selectedCard === item.value ? (
                          <>
                            <Divider className="m-0" />
                            <Box>
                              <Box sx={{ padding: "0.6rem" }}>
                                <Dropdown
                                  value={getSelectedResourceSlipInCard(
                                    item.value
                                  )}
                                  onChange={
                                    onResourceSlipSelectionChangeHandler
                                  }
                                  options={getSelectedResourceSlipsListInCard(
                                    item.value
                                  )}
                                  onClick={(e: any) => e.stopPropagation()}
                                  className="slip-dropdown"
                                />
                              </Box>
                            </Box>
                          </>
                        ) : (
                          <></>
                        )}
                      </Card>
                    );
                  })}
              </Box>
            </Grid>
          )}
          <Divider
            layout="vertical"
            align="center"
            className="verticle-divider"
            style={{ zIndex: 0 }}
          >
            <Button
              variant="outlined"
              sx={{
                minWidth: "fit-content",
                padding: "20px 0",
                borderRadius: "7px",
              }}
              onClick={onDividerButtonClickHandler}
            >
              {sidePanelsVisibility ? (
                <i
                  className="pi pi-angle-double-left"
                  style={{ color: "#0057db" }}
                ></i>
              ) : (
                <i
                  className="pi pi-angle-double-right"
                  style={{ color: "#0057db" }}
                ></i>
              )}
            </Button>
          </Divider>
          <Grid
            size={{
              xs: sidePanelsVisibility ? 8 : 10,
              sm: sidePanelsVisibility ? 8 : 10.8,
              md: sidePanelsVisibility ? 9.4 : 11.2,
              lg: sidePanelsVisibility ? 9.5 : 11.6,
              xl: sidePanelsVisibility ? 9.7 : 11.7
            }}
            sx={{ "& .MuiGrid-container": { marginTop: 0 } }}
          >
            <FormProvider {...formMethods}>
              <form onSubmit={formMethods.handleSubmit(onSubmit)}>
                <TwoColumnLayout
                  toolbar={
                    <T3SlipSetupToolbar
                      onResetClicked={onResetClicked}
                      onDeleteClicked={onDeleteClicked}
                      onPrintClicked={onPrintClicked}
                      isSubmitting={isSubmitting}
                      formMethods={formMethods}
                    />
                  }
                  leftColumnContent={
                    <>
                      {!sidePanelsVisibility && (
                        <StandardPanel
                          title="Load Slips"
                          testId={`${testId}-load-slips-panel`}
                        >
                          <Grid
                            container
                            columnSpacing={2}
                            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                          >
                            <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                              <EnhancedDropDownRHFWithLabel
                                label="Load T3 Recipient"
                                selectName="selectedVendor"
                                items={selectedResourceList}
                                selectedItem={selectedResource}
                                onSelectionChangeHandler={
                                  onResourceSelectionChangeHandler
                                }
                                testId={`${testId}-selected-vendor`}
                              />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                              <EnhancedDropDownRHFWithLabel
                                label="Load T3 Slip"
                                selectName="selectedSlip"
                                items={selectedResourceSlipList}
                                selectedItem={selectedResourceSlip}
                                onSelectionChangeHandler={
                                  onResourceSlipSelectionChangeHandler
                                }
                                testId={`${testId}-selected-slip`}
                              />
                            </Grid>
                          </Grid>
                        </StandardPanel>
                      )}
                      <StandardPanel
                        title="Slip Data"
                        testId={`${testId}-slip-data`}
                        topPadding={!sidePanelsVisibility ? 2 : 0}
                      >
                        {T3OtherInformationList && (
                          <T3SlipDataPanel
                            formMethods={formMethods}
                            testId={testId}
                            // foreignCurrencyDDL={
                            //   foreignCurrencyDDList && foreignCurrencyDDListItems
                            // }
                            oiInEdit={oiInEdit}
                            isLoading={false}
                            otherInformationList={T3OtherInformationList}
                            selectedOtherInformation={selectedOtherInformation}
                            globalVariablesData={dashboardApiData.global_variable && dashboardApiData.global_variable}
                            selectedProvinceOfEmployment={undefined}
                          />
                        )}
                      </StandardPanel>
                    </>
                  }
                  rightColumnContent={
                    <>
                      <StandardPanel
                        title="T3 Beneficiary Info"
                        testId={`${testId}-Vendor-info`}
                      >
                        <VendorInfoSetupFieldsPanel
                          testId={testId}
                          formMethods={formMethods}
                          vendorDDL={secondRecipientDDL && secondRecipientDDL}
                          individualChangeHandler={
                            onIndividualSelectionChangeHandler
                          }
                          isLoading={(value: boolean) =>
                            setIsLoadingAdjustedData(value)
                          }
                          resourceDDLWithRecipientType={(value: any) =>
                            setSelectedResourceList(value)
                          }
                          secondRecipientDDLData={(value: any) => setSecondRecipientDDL(value)}
                          resourceDDLWithoutCreateNewWithRecipientType={(
                            value: any
                          ) => setResourceListWithoutCreateNew(sortData(value))}
                          globalVariablesData={
                            dashboardApiData.global_variable && dashboardApiData.global_variable
                          }
                        />
                      </StandardPanel>
                      <StandardPanel
                        title="Address"
                        testId={`${testId}-Vendor-address-panel`}
                        topPadding={2}
                      >
                        <VendorAddressSetupFieldsPanel testId={testId} />
                      </StandardPanel>
                      <StandardPanel
                        title="Filing Data"
                        testId={`${testId}-filing-data-panel`}
                        topPadding={2}
                      >
                        <EnhancedDropDownRHFWithLabel
                          label="Slip Type"
                          selectName="slipType"
                          items={[
                            { label: "Original", value: 400 },
                            { label: "Amended", value: 200 },
                            { label: "Cancelled", value: 300 },
                            { label: "Additional", value: 100 },
                          ]}
                          selectedItem={400}
                          testId="slip-type"
                          labelPosition={LabelPosition.Left}
                          required
                          onSelectionChangeHandler={
                            onSlipTypeSelectionChangeHandler
                          }
                        />
                        <FilingDataSetupFieldsPanel testId={testId} />
                      </StandardPanel>
                    </>
                  }
                  testId="t4-slip-setup-form"
                />
              </form>
            </FormProvider>
          </Grid>
        </Grid>
        {/* invoice dialogu open if any transaction is unPaid */}
        <EnhancedDialog
          dialogTitle="Invoice(s) Due"
          key="dialog-box"
          testId="dialog"
          onCloseHandler={onCloseHandler}
          open={openInvoiceDialog}
          dialogContent={
            <InvoiceDialogPanel
              invoiceData={invoiceData}
              onUnPaidClickHandler={onUnPaidClickHandler}
              onClickInvoiceNoHandler={onClickInvoiceNoHandler}
            />
          }
          dialogAction={
            <Grid>
              <Button autoFocus variant="contained" onClick={onCloseHandler}>
                Cancel
              </Button>
            </Grid>
          }
        />
        <EnhancedSnackbar
          message={snackbarData.message}
          onCloseHandler={onSnackbarClosed}
          severity={snackbarData.severity}
          testId={`${testId}-snackbar`}
          open={snackbarData.open}
          autoHide={snackbarData.autoHide}
        />
      </Grid>
    </>
  );
};
